// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  useSubAccountsMockData: false,
  useAppLovinMediationMockData: false,
  useAppLovinAppsMockData: false,
  useAppLovinAdUnitsMockData: false,
  useRemoteAppLovinAdUnitsMockData: false,
  facebookAppId: "1018352715736209",
  useDeactivationAlgorithmMockData: false,
  useDeactivationAlgorithmMauMockData: false,
  useReactivationAlgorithmMauMockData: false,
  useEcpmAlgorithmMockData: false,
  useStartABTestAlgorithmMockData: false,
  useWaterfallGroupsMockData: false,
  useLevelPlayMediationAccountsMockData: false,
  useRemoteLevelPlayAdUnitsMockData: false,
  useAppAdUnitsMockData: false,
  useLevelPlayLocalAdUnitsMockData: false,
};
